import { api } from './api';

export const fetchAccountCreditById = (params) => {
  return api.get('/credit', params);
};

export const fetchAddCredit = (payload) => {
  return api.post('/credit', payload);
};

export const fetchRevokeCredit = (id) => {
  return api.post(`/credit/${id}/revoke`, {});
};
